import type { Dex } from "@auto-pools/core/contracts";
import { dexName } from "../lib/dex";

/** A quiet neutral chip (design 60): Orca carries it too, so neither DEX reads as the default. */
export function DexBadge({ dex }: { dex: Dex | undefined }) {
  return <span className="dex-badge">{dexName(dex)}</span>;
}
